import { writable } from '../external_node_modules/svelte/store/index.mjs.js';

const bindingManagementUrl = null;
const { subscribe, update } = writable(bindingManagementUrl);
function setBindingManagementUrl(bindingManagementUrl) {
    return update((state) => {
        state = bindingManagementUrl;
        return state;
    });
}

export { setBindingManagementUrl };
//# sourceMappingURL=bindingManagementUrl.js.map
